import { useEffect, useRef, useState } from "react";
import Image from "next/image";
const SelectInput = (props: any) => {
  const {
    clearClicked,
    handleClearComplete,
    cls,
    cls2,
    cls3,
    placeholder,
    label,
    errorMessage,
    onSelect,
    width,
    isMultiple,
    isNoBorderLeft,
    isNoBorderRight,
    options,
    initialSelected,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [dropdownValue, setDropdownValue] = useState(placeholder);
  const [num, setNum] = useState(0);
  const initialEffectRan = useRef(false);
  const [searchTerm, setSearchTerm] = useState("");
  const filteredOptions = options.filter((option: any) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  useEffect(() => {
    if (initialSelected && !initialEffectRan.current) {
      initialSelected.forEach((item: any) => {
        handleItemClick(item, true);
      });
      initialEffectRan.current = true;
    }
  }, []);

  const handleItemClick = (value: any, initialSelect: boolean = false) => {
    if (isMultiple) {
      if (selectedItems.indexOf(value) !== -1) {
        setSelectedItems((prevSelectedItems) =>
          prevSelectedItems.filter((selected) => selected !== value),
        );
        setNum((prevNum: number) => prevNum - 1);
      } else {
        setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
        setNum((prevNum: number) => prevNum + 1);
      }
    } else {
      setDropdownValue(value);
      setIsOpen(false);
    }
    if (!initialSelect) {
      onSelect(value);
    }
  };

  const handleMouseLeave = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  const handleClear = () => {
    setSelectedItems([]);
    setNum(0);
    setDropdownValue(placeholder);
    onSelect([]);

  };

  useEffect(() => {
    if (clearClicked) {
      handleClear();
    }
  }, [clearClicked]);

  return (
    <>
      <div
        className={`relative inline-block w-[${width}] ${cls2}`}
        onMouseLeave={handleMouseLeave}
      >
        <p className="bdy-txt-5 mb-2">{label}</p>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`w-[${width}] flex bg-white border border-solid border-black px-4 h-[50px] py-1.5 items-center justify-between ${cls} ${isOpen ? "border-b-1" : ""
            }
            ${isNoBorderLeft ? " xl:border-l-0 " : ""}
              ${isNoBorderRight ? "xl:border-r-0" : ""}
            `}
        >
          <span className="bdy-txt-1 overflow-hidden whitespace-nowrap overflow-ellipsis">
            {dropdownValue}{" "}
            {num > 0 && (
              <span className="num bg-teal-900 rounded-full w-6 h-6 text-white absolute ml-2 p-[2px] -mt-[3px] lg:p-0 lg:mt-0">
                {num}
              </span>
            )}
          </span>
          <Image
            width={15}
            height={20}
            alt="arrow"
            className="cursor-pointer"
            src="/assets/icons/arrow-down.svg"
          ></Image>
        </button>
        {isOpen && (
          <div
            className={`${isOpen ? "block" : "hidden"
              } absolute bg-white border z-10 border-solid border-black max-h-[400px] overflow-y-auto  ${cls3} w-[${width}] ${isOpen ? "border-t-0" : ""
              }`}
          >
            <ul>
              {isMultiple ? (
                <li className="p-2 pl-4 pr-4 items-center bdy-txt-2 text-left border border-solid border-black border-t-0 border-r-0 border-l-0 cursor-pointer">
                  <div>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="p-[3px] mb-2 mt-2 w-full border border-solid border-black pl-[10px] search-input text-[15px]"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>{" "}
                  <span onClick={handleClear}> Clear All </span>
                </li>
              ) : null}
              {isMultiple
                ? filteredOptions.map((option: any, index: number) => (
                  <li
                    key={index}
                    className={`p-[5px] pl-4 items-center cursor-pointer ${index == 0 ? "mt-[10px]" : ""
                      }`}
                  >
                    <input
                      type="checkbox"
                      className="cursor-pointer w-4 h-4 custom-checkbox"
                      onChange={() => handleItemClick(option.value)}
                      checked={selectedItems.indexOf(option.value) !== -1}
                    />
                    <span
                      className="ml-2 items-center dropwon-list break-all relative -top-[2px]"
                      onClick={() => handleItemClick(option.value)}
                    >
                      {option.label}
                    </span>
                  </li>
                ))
                : options.map((option: any, index: number) => (
                  <li
                    key={index}
                    className="p-2 pl-4 cursor-pointer"
                    onClick={() => handleItemClick(option.value)}
                  >
                    <span className="bdy-txt-2">{option.label}</span>
                  </li>
                ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};
export default SelectInput;
